<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <div @click="hideMenu()">
    <!-- FILTROS -->
    <div class="card">
      <div class="card-header">
        <button style="float: left; margin-top: -5px" type="button" class="btn btn-tool" data-toggle="collapse" href="#collapse1">
          <i class="fas fa-minus"></i>
        </button>
        <h5 class="card-title" id="accordion">Filtrar habilitações</h5>
      </div>
      <!--<div id="collapse1" class="collapse" data-parent="#accordion"> -->
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="endereco_estado">Data próx. praça DE:</label>
              <input id="dataInicio" class="form-control" name="dataInicio" type="date" v-model="dataInicio" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="endereco_cidade">Data próx. praça ATÉ:</label>
              <input id="dataFim" class="form-control" type="date" v-model="dataFim" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Apelido</label>
              <input class="form-control" id="descricao" v-model="apelido" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="nome">Leilão id</label>
              <input class="form-control" id="descricao" v-model="leilao_id" style="text-transform: uppercase" />
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="endereco_estado">Exibir</label>

              <select class="custom-select rounded-0" id="endereco_estado" v-model="tipo_exibicao" @change="buscarHabilitacoes(true)">
                <option value="todas">Todas solicitações</option>
                <option value="pendentes">Somente pendentes</option>
                <option value="bloqueadas">Somente bloqueadas</option>
                <option value="liberadas">Somente liberadas</option>
              </select>
            </div>
          </div>
          <!--
          <div class="col-4 col-sm-12 col-md-4">
            <div class="form-group">
              <input
                style="height: 25px; width: 25px; position: absolute; margin-top: 5px"
                v-model="somente_pendentes"
                type="checkbox"
                @change="buscarHabilitacoes()"
              />
              <label for="estado_civil" class="input-group-text my-group-text" style="position: absolute; margin-left: 25px">
                Somente habilitações pendentes
              </label>
            </div>
          </div>
          -->

          <div class="col-sm-12">
            <div class="form-group">
              <button type="button" class="btn btn-primary" @click="buscarHabilitacoes(true)">Buscar</button>

              <button type="button" class="btn btn-default" @click="limparFiltros" style="margin-left: 15px">Limpar filtros</button>
            </div>
          </div>
        </div>
        <!--  </div> -->
      </div>
    </div>

    <!-- TABELA DE habilitacoes -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Habilitações</h3>
        <div class="card-tools">
          <!-- PAGINAÇÃO  -->
          <ul class="pagination pagination-sm m-0 float-right">
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

            <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
              <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
                {{ pagina }}
              </a>
            </li>

            <li class="page-item">
              <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
            </li>
            <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
          </ul>
        </div>
      </div>
      <div class="card-body table-responsive p-0">
        <table class="table table-hover text-nowrap" style="position: relative">
          <thead>
            <tr>
              <th>Seq</th>
              <th>Apelido</th>
              <th>Leilão</th>
              <th>Solicitação</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(habilitacao, index) in habilitacoes"
              :key="habilitacao"
              :style="getStyle(habilitacao.user_status)"
              :class="getClass(habilitacao.user_status)"
            >
              <td data-label="Seq">{{ index + 1 }}</td>

              <td data-label="Apelido">
                <div>
                  <b>Apelido:&nbsp;</b>
                  <i class="fa-solid fa-circle" style="margin-right: 3px; margin-left: 3px" :style="getStyleOnline(habilitacao)"></i>
                  <a :href="'/admin/cadastros/detalhes/' + habilitacao.user_id">{{ habilitacao.apelido }}</a>
                </div>
                <div>
                  <b>Status usuário:&nbsp;</b>
                  <span class="right badge badge-success" style="margin-left: 5px" v-if="habilitacao.user_status == 'liberado'">LIBERADO</span>
                  <span
                    class="right badge badge-danger"
                    style="margin-left: 5px; background-color: #dbb50a"
                    v-else-if="habilitacao.user_status == 'pendente'"
                  >
                    PENDENTE
                  </span>
                  <span class="right badge badge-danger" style="margin-left: 5px" v-else-if="habilitacao.user_status == 'bloqueado'">BLOQUEADO</span>
                  <span class="right badge badge-danger" style="text-transform: uppercase; margin-left: 5px; background-color: gray" v-else>
                    {{ habilitacao.user_status }}
                  </span>
                </div>

                <!--
                <div class="card" style="background-color: rgb(219, 181, 10) !important" v-if="habilitacao.pendencias.length">
                  <div class="card-body p-2">
                    <i class="fa-solid f  a-circle-exclamation"></i>
                    <p v-for="(pendencia, index) in habilitacao.pendencias" :key="pendencia">
                      <span v-html="pendencia.conteudo"></span>
                    </p>
                  </div>
                </div>
                -->
              </td>

              <td data-label="Leilão">
                <div>
                  <b>Leilão:&nbsp;</b>
                  <a href="#" data-toggle="modal" data-target="#detalhes-leilao-modal" @click="habilitacao_selecionada = habilitacao">
                    {{ habilitacao.leilao_id }} - {{ habilitacao.leilao_titulo }}

                    <span
                      style="margin-left: 5px; text-transform: uppercase"
                      v-if="habilitacao.possui_lote_sucata_restricao > 0"
                      class="right badge badge-warning"
                    >
                      Contém sucata
                    </span>
                  </a>
                  <!-- <a :href="'/admin/leilao/' + habilitacao.leilao_id">{{ habilitacao.leilao_id }} - {{ habilitacao.leilao_titulo }}</a>-->
                </div>
                <div>
                  <b>Dt. Próx Praça:</b>
                  {{ getDataProximaPraca(habilitacao) }}
                </div>
                <div>
                  <span
                    style="text-transform: uppercase"
                    v-if="habilitacao.lotes_categorias_aviso && habilitacao.lotes_categorias_aviso.length > 0"
                    class="right badge badge-danger"
                  >
                    {{ habilitacao.lotes_categorias_aviso[0].nome }}
                  </span>
                </div>
                <div>
                  <b>Comitente:</b>
                  {{ habilitacao.comitente }} - {{ habilitacao.cidade_comitente }}/{{ habilitacao.estado_comitente }}
                </div>
              </td>

              <td data-label="Solicitação">
                <div>
                  <b>Data solicitação:&nbsp;</b>
                  {{ formatDate(habilitacao.created_at) }}
                </div>
                <div>
                  <b>IP:&nbsp;</b>
                  {{ habilitacao.ip }}
                </div>
                <div>
                  <b>Status habilitação:&nbsp;</b>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'liberado'" class="right badge badge-success">
                    {{ habilitacao.status }}
                  </span>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'bloqueado'" class="right badge badge-danger">
                    {{ habilitacao.status }}
                  </span>

                  <span style="text-transform: uppercase" v-if="habilitacao.status == 'aguardando'" class="right badge badge-warning">
                    {{ habilitacao.status }}
                  </span>
                </div>

                <div
                  class="card"
                  style="margin-top: 5px; margin-top: 5px; margin-bottom: 5px; background-color: #dc3545 !important; color: white"
                  v-if="habilitacao.motivo_bloqueio"
                >
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="color: white"></i>
                    <b style="margin-left: 3px; font-size: 18px">Motivo bloqueio:</b>
                    <p style="margin-top: 5px; font-size: 18px; color: white">{{ habilitacao.motivo_bloqueio }}</p>
                  </div>
                </div>

                <div
                  class="card"
                  style="color: black; margin-top: 5px; margin-bottom: 5px; background-color: rgb(219, 181, 10) !important"
                  v-if="habilitacao && habilitacao.motivo_pendencia"
                >
                  <div class="card-body p-2">
                    <i class="fa-solid fa-circle-exclamation" style="color: white"></i>
                    <b style="margin-left: 3px; font-size: 18px; color: white">Motivo pendência:</b>
                    <p style="margin-top: 5px; font-size: 18px; color: white">{{ habilitacao.motivo_pendencia }}</p>
                  </div>
                </div>
              </td>

              <td>
                <a
                  id="navbarDropdown"
                  class="nav-link"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-pre
                >
                  <i class="fa-solid fa-bars" style="color: gray"></i>
                </a>

                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'liberado'" @click="buscarEmail('Liberarhabilitacao', 'liberar', habilitacao)" class="dropdown-item">
                    LIBERAR
                  </a>
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'liberado'" @click="aprovar(0, habilitacao)" class="dropdown-item">LIBERAR SEM NOTIFICAR</a>
                  <div class="dropdown-divider"></div>
                  <a
                    v-if="habilitacao.status != 'bloqueado'"
                    @click="buscarEmail('Bloquearhabilitacao', 'bloquear', habilitacao)"
                    class="dropdown-item"
                  >
                    BLOQUEAR
                  </a>
                  <div class="dropdown-divider"></div>
                  <a v-if="habilitacao.status != 'bloqueado'" @click="bloquear(0, habilitacao)" class="dropdown-item">BLOQUEAR SEM NOTIFICAR</a>

                  <!--
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#motivo-pendencia-modal"
                    @click="selecionarHabilitacao(habilitacao)"
                    style="cursor: pointer"
                  >
                    ADICIONAR PENDÊNCIA SEM NOTIFICAR
                  </a>
                  -->

                  <!--
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    data-toggle="modal"
                    data-target="#motivo-bloqueio-modal"
                    @click="selecionarHabilitacao(habilitacao)"
                    style="cursor: pointer"
                  >
                    ADICIONAR MOTIVO BLOQUEIO
                  </a>
                  -->
                  <!--
                  <div class="dropdown-divider"></div>
                  <a class="dropdown-item" @click="removerPendencia(habilitacao)" style="cursor: pointer">REMOVER PENDÊNCIA SEM NOTIFICAR</a>
-->
                  <div v-if="habilitacao.motivo_bloqueio" class="dropdown-divider"></div>
                  <a v-if="habilitacao.motivo_bloqueio" class="dropdown-item" @click="removerMotivoBloqueio(habilitacao)" style="cursor: pointer">
                    REMOVER MOTIVO BLOQUEIO
                  </a>
                </div>
              </td>

              <!--
              <td>
                <div v-if="habilitacao.status != 'liberado'">
                  <button type="button" class="btn btn-success" style="color: white; width: 100%; padding: 1px 1px 1px 1px">
                    Aprovar habilitação
                  </button>
                </div>
                <div v-if="habilitacao.status != 'bloqueado'">
                  <button
                    @click="opcoesHabilitacaoBloquear($event, habilitacao)"
                    type="button"
                    class="btn btn-warning"
                    style="color: white; width: 100%; padding: 1px 1px 1px 1px"
                  >
                    Bloquear habilitação
                  </button>
                </div>
              </td>
              -->
            </tr>
          </tbody>
        </table>

        <div
          id="newMenu"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div style="text-align: center; margin-top: 5px; margin-bottom: 5px">
            <b>Habilitação #{{ habilitacao_selecionada.id }}</b>
          </div>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="buscarEmail('Liberarhabilitacao', 'liberar')" style="cursor: pointer">LIBERAR</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="aprovar(0)" style="cursor: pointer">LIBERAR SEM NOTIFICAR</a>
        </div>
        <div
          id="newMenuBloquear"
          style="visibility: hidden; position: absolute; background-color: white; max-width: 300px; line-height: 15px"
          class="dropdown-menu-lg dropdown-menu-right"
        >
          <div style="text-align: center; margin-top: 5px; margin-bottom: 5px">
            <b>Habilitação #{{ habilitacao_selecionada.id }}</b>
          </div>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="buscarEmail('Bloquearhabilitacao', 'bloquear')" style="cursor: pointer">BLOQUEAR</a>

          <div class="dropdown-divider"></div>
          <a class="dropdown-item" @click="bloquear(0)" style="cursor: pointer">BLOQUEAR SEM NOTIFICAR</a>
        </div>
      </div>

      <div class="card-footer clearfix">
        <!-- TOTAIS  -->
        <div style="font-size: 13px" class="float-left" aria-live="polite">
          Exibindo do {{ inicio + 1 }} ao {{ inicio + habilitacoes.length }}
          <p>Total {{ total }}</p>
        </div>

        <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

        <select @change="alterarQtdPagina()" class="float-left card-titlecustom-select rounded-0" style="font-size: 12px" v-model="qtd_por_pagina">
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
          <option :value="200">200</option>
        </select>

        <div class="card-tools">
          <div class="input-group input-group-sm" style="width: 150px"></div>
        </div>

        <!-- PAGINAÇÃO  -->
        <ul class="pagination pagination-sm m-0 float-right">
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(1)">&Lt;</a></li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(pagina_atual - 1)">&lt;</a></li>

          <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
            <a :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'" class="page-link" href="#" @click="selecionarPagina(pagina)">
              {{ pagina }}
            </a>
          </li>

          <li class="page-item">
            <a class="page-link" href="#" @click="selecionarPagina(pagina_atual + 1)">&gt;</a>
          </li>
          <li class="page-item"><a class="page-link" href="#" @click="selecionarPagina(max_page)">&Gt;</a></li>
        </ul>
      </div>
    </div>

    <!-- MODAL DETALHES LEILÃO -->
    <div class="modal fade" id="detalhes-leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <div class="card">
                <div
                  class="card-body"
                  style="
                    padding: 0px 0px 0px 0px;
                    text-align: left;
                    font-family: 'Montserrat', sans-serif;
                    text-transform: uppercase;
                    margin: 0px 0px 0px 0px;
                  "
                >
                  <div style="text-align: left; line-height: 5px" class="p-2">
                    <div style="margin-top: 7px; position: relative">
                      <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                        {{ habilitacao_selecionada.cidade_leilao }} - {{ habilitacao_selecionada.estado_leilao }}
                      </p>
                      <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                        {{ getFormatedTitle(habilitacao_selecionada.leilao_titulo) }}
                      </span>
                      <br />
                    </div>
                  </div>

                  <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
                    <b style="font-size: 14px">
                      Modalidade:
                      <a style="color: #4a4949; font-weight: 400">{{ habilitacao_selecionada.leilao_1_modalidade }}</a>
                    </b>
                    <br />
                    <b style="font-size: 14px">
                      Local:
                      <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ habilitacao_selecionada.leilao_local }}</a>
                    </b>
                  </div>
                  <!-- DATAS E VALORES DOS LEILÕES -->
                  <div v-if="habilitacao_selecionada.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
                    <div style="font-size: 14px; color: #545353" :class="habilitacao_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''">
                      <b>1º Leilão:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_1_data) + "h" }}
                    </div>

                    <!-- DATA 2 -->
                    <div style="font-size: 14px; color: #545353" v-if="habilitacao_selecionada.leilao_num_pracas >= 2">
                      <b>2º Leilão:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_2_data) + "h" }}
                    </div>

                    <!-- DATA 3 -->
                    <div style="font-size: 14px; color: #545353" v-if="habilitacao_selecionada.leilao_num_pracas >= 3">
                      <b>3º Leilão:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_3_data) + "h" }}
                    </div>

                    <!-- DATA 4 -->
                    <div style="font-size: 14px; color: #545353" v-if="habilitacao_selecionada.leilao_num_pracas >= 4">
                      <b>4º Leilão:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_4_data) + "h" }}
                    </div>
                  </div>

                  <!-- ÚNICO LEILÃO-->
                  <div
                    v-else-if="habilitacao_selecionada.leilao_num_pracas == 1 && !venda_direta"
                    style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
                    class="p-1"
                  >
                    <div
                      style="font-size: 14px; color: #545353; margin-bottom: 3px"
                      :class="habilitacao_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''"
                    >
                      <b>Único leilão:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_1_data) + "h" }}
                    </div>
                  </div>

                  <!-- VENDA DIRETA-->
                  <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
                    <p style="font-size: 14px; margin-top: 5px">{{ habilitacao_selecionada.leilao_local }}</p>
                    <div style="font-size: 14px; color: #545353" :class="habilitacao_selecionada.leilao_1_realizado === 1 ? 'realizado' : ''">
                      <b style="">Disponível até:</b>
                      {{ formatDate(habilitacao_selecionada.leilao_1_data) + "h" }}
                      <br />
                      <a>Pelo valor de</a>
                      R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
                    </div>
                  </div>

                  <!-- ID DO LEILÃO-->
                  <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">
                    Leilão ID {{ habilitacao_selecionada.leilao_id }}
                    <!--
                    <a :href="'/admin/leilao/' + habilitacao_selecionada.leilao_id">
                      {{ habilitacao_selecionada.leilao_id }}
                    </a>
                    -->

                    <a style="margin-left: 5px" @click="getUrlLeilao(habilitacao_selecionada)" href="#">Site</a>
                  </span>

                  <button
                    style="font-size: 12px; border-radius: 2px; margin-left: 5px; margin-bottom: 12px"
                    type="submit"
                    class="btn btn-default"
                    title="Habilitações"
                    alt="Habilitações"
                  >
                    <div>
                      <i class="fa-solid fa-laptop"></i>
                      {{ habilitacao_selecionada.total_habilitacoes }}
                    </div>
                  </button>
                </div>
              </div>

              <button data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL MOTIVO PENDÊNCIA -->
    <div class="modal fade" id="motivo-pendencia-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Adicionar pendência</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>

                  <textarea class="form-control" rows="4" cols="50" v-model="motivo_pendencia"></textarea>
                </div>
              </div>

              <button @click="salvarPendencia()" class="btn btn-primary btn-sm">Salvar</button>

              <button id="fechar_motivo_pendencia_modal" style="margin-left: 15px" data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL MOTIVO BLOQUEIO -->
    <div class="modal fade" id="motivo-bloqueio-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Motivo bloqueio</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Conteúdo</label>

                  <textarea class="form-control" rows="4" cols="50" v-model="motivo_bloqueio"></textarea>
                </div>
              </div>

              <button @click="salvarPendencia()" class="btn btn-primary btn-sm">Salvar</button>

              <button id="fechar_motivo_bloqueio_modal" style="margin-left: 15px" data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <!-- MODAL EMAIL HABLITAÇÃO -->
    <div class="modal fade" id="email-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <form @submit.prevent>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4>Email</h4>
              <br />

              <div class="col-sm-12">
                <div class="form-group">
                  <label for="leilao_info_geral">Assunto</label>

                  <input class="form-control" id="id" v-model="formData.assunto_email" />

                  <span style="color: red" v-for="error in v$.assunto_email.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <div class="col-sm-12" v-if="mail_template.possui_texto_padrao">
                <div class="form-group">
                  <label>Textos padrão</label>

                  <div class="input-group">
                    <select class="custom-select rounded-0" v-model="texto_selecionado" @change="updateText(texto_selecionado.conteudo, false)">
                      <option v-for="texto in textos_padrao" :value="texto" :key="texto">{{ texto.titulo }}</option>
                    </select>
                    <div class="input-group-append">
                      <button
                        style="max-height: 40px"
                        type="submit"
                        class="btn btn-default"
                        data-toggle="modal"
                        data-target="#texto-padrao-modal"
                        @click="criar_texto_padrao = true"
                      >
                        <i class="fas fa-plus"></i>
                        Novo texto
                      </button>
                      <button
                        style="max-height: 40px"
                        type="submit"
                        class="btn btn-default"
                        data-toggle="modal"
                        data-target="#listar-textos-modal"
                        @click="listar_textos_padrao = true"
                      >
                        <i class="fas fa-search"></i>
                        Listar textos
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <admin-listar-textos-padrao v-if="listar_textos_padrao" :setListarTextos="setListarTextos" />
              <admin-cadastrar-texto-padrao v-if="criar_texto_padrao" :setCriarTexto="setCriarTexto" :textoCriado="textoCriado" />

              <div class="col-sm-12">
                <div class="form-group">
                  <label id="editor_conteudo" for="leilao_info_geral">Conteúdo</label>

                  <Editor style="background-color: white" editorStyle="height: 200px" v-model="formData.corpo_email" />

                  <span style="color: red" v-for="error in v$.corpo_email.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <button @click="validate()" class="btn btn-primary btn-sm">Enviar e-mail e {{ acao }}</button>

              <button id="fechar_email_modal" style="margin-left: 15px" data-toggle="modal" data-target="#email-modal" class="btn btn-danger btn-sm">
                Fechar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import auxFormatarEmail from "../../controller/auxFormatarEmail";
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";

import useVueLidate from "@vuelidate/core";
import { computed, reactive } from "vue";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";

export default {
  props: [],

  mixins: [sweetAlert, Swal, AuxController, auxFormatarEmail],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      logo_selecionado: "",
      filtro: "",
      paginas: [],
      habilitacoes: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      habilitacao_selecionada: "",
      somente_pendentes: true,
      apelido: "",
      leilao_id: "",
      mail_template: "",
      acao: "",
      motivo_pendencia: "",
      motivo_bloqueio: "",
      texto_selecionado: "",
      criar_texto_padrao: false,
      listar_textos_padrao: false,
      textos_padrao: [],
      tipo_exibicao: "pendentes",
      max_page: 0,
      dataInicio: "",
      dataFim: "",
      venda_direta: false,
    };
  },

  setup() {
    const formData = reactive({
      corpo_email: "",
      assunto_email: "",
    });

    const rules = computed(() => {
      return {
        corpo_email: { required },
        assunto_email: { required },
      };
    });

    const aceitarTermos = (value) => {
      return value;
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let page = urlParams.get("page");

    if (page) {
      this.pagina_atual = Number(page);
    }

    this.dataInicio = moment(new Date()).format("yyyy-MM-DD");
    //this.dataFim = moment(new Date()).format("yyyy-MM-DD");

    this.buscarHabilitacoes();
  },

  methods: {
    getUrlLeilao(habilitacao) {
      if (habilitacao.total_lotes > 1) {
        window.open("/leilao/" + habilitacao.leilao.id + "/lotes");
      } else {
        window.open("/lote/" + habilitacao.primeiro_lote_id);
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    updateText(html, isBefore) {
      console.log(window.getSelection());
      console.log(window.getSelection().focusNode);
      console.log(window.getSelection().focusNode.parentElement.className);
      console.log(window.getSelection().focusNode.parentElement.parentElement.className);

      let hasParent = true;
      let isEditor = false;
      let currentNode = window.getSelection().focusNode;
      let cont = 1;

      while (hasParent) {
        if (currentNode.className && currentNode.className.includes("ql-editor")) {
          console.log("True no nível " + cont);
          isEditor = true;
          hasParent = false;
        } else {
          if (!currentNode.parentElement) {
            hasParent = false;
            console.log("Não possui parent nivel " + cont);
          } else {
            currentNode = currentNode.parentElement;
          }
        }
        cont++;
      }

      if (isEditor) {
        /*
      console.log(window.getSelection());
      console.log(window.getSelection().focusNode);
      console.log(window.getSelection().focusNode.parentElement);
      console.log(window.getSelection().focusNode.parentElement.parentElement);
      console.log(window.getSelection().focusNode.parentElement.parentElement.className);
      */

        //html = " " + html + " ";

        var sel, range, node;
        if (window.getSelection) {
          sel = window.getSelection();

          if (sel.getRangeAt && sel.rangeCount) {
            range = window.getSelection().getRangeAt(0);
            range.collapse(isBefore);

            var el = document.createElement("div");
            el.innerHTML = html;
            var frag = document.createDocumentFragment(),
              node,
              lastNode;
            while ((node = el.firstChild)) {
              lastNode = frag.appendChild(node);
            }
            range.insertNode(frag);

            this.texto_selecionado = null;
          }
        } /* else if (document.selection && document.selection.createRange) {
        range = document.selection.createRange();
        range.collapse(isBefore);
        range.pasteHTML(html);
      }*/
      }
    },

    setListarTextos() {
      let btn = document.getElementById("fechar_listar_texto_modal");

      if (btn) {
        btn.click();
        this.buscarTextosPadrao();
      }

      this.listar_textos_padrao = false;
    },

    textoCriado(data) {
      let btn = document.getElementById("fechar_texto_modal");

      btn.click();

      this.textos_padrao.push(data);

      console.log("Ordenando");

      //ALFABÉTICO
      this.textos_padrao.sort(function (a, b) {
        if (a.titulo < b.titulo) {
          return -1;
        }
        if (a.titulo > b.titulo) {
          return 1;
        }
        return 0;
      });

      this.setCriarTexto(false);
    },

    setCriarTexto(value) {
      let btn = document.getElementById("fechar_texto_modal");

      if (btn) {
        btn.click();
      }

      this.criar_texto_padrao = false;
    },

    buscarTextosPadrao() {
      let data = {
        inicio: this.inicio,
        tamanho: 10000,
      };

      axios
        .post(`/admin/texto_padrao/search`, data)
        .then((response) => {
          this.textos_padrao = response.data.textos_padrao;

          this.pagination(response.data);

          console.log(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    removerMotivoBloqueio(habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      this.isLoading = true;

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        motivo_pendencia: this.motivo_pendencia,
        motivo_bloqueio: null,
      };

      axios
        .post(`/admin/habilitacoes/update_pendencia`, data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessageWithButton("Sucesso", "Motivo de bloqueio removido.");

          document.getElementById("fechar_motivo_pendencia_modal").click();
          document.getElementById("fechar_motivo_bloqueio_modal").click();

          this.habilitacao_selecionada.motivo_bloqueio = null;
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    removerPendencia(habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      this.isLoading = true;

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        motivo_pendencia: null,
        motivo_bloqueio: this.motivo_bloqueio,
      };

      axios
        .post(`/admin/habilitacoes/update_pendencia`, data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessageWithButton("Sucesso", "Pendência removida.");

          document.getElementById("fechar_motivo_pendencia_modal").click();
          document.getElementById("fechar_motivo_bloqueio_modal").click();

          this.habilitacao_selecionada.motivo_pendencia = null;
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    salvarPendencia() {
      this.isLoading = true;

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        motivo_bloqueio: this.motivo_bloqueio,
        motivo_pendencia: this.motivo_pendencia,
      };

      axios
        .post(`/admin/habilitacoes/update_pendencia`, data)
        .then((response) => {
          this.isLoading = false;
          this.showSuccessMessageWithButton("Sucesso", "Habilitação atualizada.");

          document.getElementById("fechar_motivo_pendencia_modal").click();
          document.getElementById("fechar_motivo_bloqueio_modal").click();

          this.habilitacao_selecionada.motivo_bloqueio = this.motivo_bloqueio;
          this.habilitacao_selecionada.motivo_pendencia = this.motivo_pendencia;
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    selecionarHabilitacao(habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      this.motivo_pendencia = habilitacao.motivo_pendencia;
      this.motivo_bloqueio = habilitacao.motivo_bloqueio;
    },

    getClass(status) {
      if (status == "pendente") {
        return "table_todos_line";
      } else if (status == "liberado") {
        return "table_todos_line";
      } else if (status == "bloqueado") {
        return "table_todos_line";
      } else {
        return "";
      }
    },

    getStyleOnline(user) {
      let online = false;

      if (user.last_seen) {
        let dataReferencia = moment(new Date());
        let data = moment(user.last_seen);

        var duration = moment.duration(dataReferencia.diff(data));
        var min = duration.asMinutes();

        if (min <= 5) {
          online = true;
        }
      }

      if (online) {
        return "color: #007d41";
      } else {
        return "color: gray;";
      }
    },

    getDataProximaPraca(habilitacao) {
      if (habilitacao.leilao_num_pracas >= 1 && habilitacao.leilao_1_realizado == 0) {
        return this.formatDate(habilitacao.leilao_1_data);
      } else if (habilitacao.leilao_num_pracas >= 2 && habilitacao.leilao_2_realizado == 0) {
        return this.formatDate(habilitacao.leilao_2_data);
      } else if (habilitacao.leilao_num_pracas >= 3 && habilitacao.leilao_3_realizado == 0) {
        return this.formatDate(habilitacao.leilao_3_data);
      } else if (habilitacao.leilao_num_pracas >= 4 && habilitacao.leilao_4_realizado == 0) {
        return this.formatDate(habilitacao.leilao_4_data);
      }
    },

    async validate() {
      const result = await this.v$.$validate();

      if (result) {
        if (this.acao == "liberar") {
          this.aprovar(1, this.habilitacao_selecionada);
        } else if (this.acao == "bloquear") {
          this.bloquear(1, this.habilitacao_selecionada);
        }
      }
    },

    buscarEmail(tipo, acao, habilitacao) {
      this.buscarTextosPadrao();

      this.acao = acao;
      this.habilitacao_selecionada = habilitacao;

      let data = {
        tipo: tipo,
      };

      axios
        .post(`/admin/mail_template/find_by_tipo`, data)
        .then((response) => {
          let btn = document.getElementById("fechar_email_modal").click();

          this.mail_template = response.data.mail_template;

          this.formData.assunto_email = this.mail_template.assunto;
          this.formData.corpo_email = this.mail_template.corpo + this.mail_template.rodape;

          console.log(this.mail_template);
        })
        .catch((error) => {
          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    limparFiltros() {
      this.somente_pendentes = true;
      this.apelido = "";
      this.leilao_id = "";

      this.dataInicio = "";
      this.dataFim = "";

      document.getElementById("dataInicio").value = "";
      document.getElementById("dataFim").value = "";

      this.buscarHabilitacoes();
    },

    getStyle(status) {
      let style = "cursor:pointer;";

      if (status == "pendente") {
        return style + "background-color: #fcfdcd";
      } else if (status == "liberado") {
        return style + "background-color: #d6fbe4";
      } else if (status == "bloqueado") {
        return style + "background-color: #ffdbdb";
      } else {
        return style;
      }
    },

    hideMenu() {
      let newMenu = document.getElementById("newMenu");
      newMenu.style.visibility = "hidden";

      newMenu = document.getElementById("newMenuBloquear");
      newMenu.style.visibility = "hidden";
    },

    opcoesHabilitacaoBloquear(event, habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      let data = {
        habilitacao_id: habilitacao.id,
        acao: this.acao,
      };

      axios
        .post(`/admin/habilitacao/validar`, data)
        .then((response) => {
          if (response.data.success) {
            let newMenu = document.getElementById("newMenuBloquear");
            let x = event.clientX - 300;
            let y = event.pageY - 140;

            let winWidth = window.innerWidth;
            let cmWidth = newMenu.offsetWidth;

            x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

            console.log("X depois " + x);

            newMenu.style.top = y + "px";
            newMenu.style.left = x + "px";
            newMenu.style.visibility = "visible";
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/admin/habilitacoes");
          }
        })
        .catch((error) => {
          if (typeof error == "object") {
            if (error.response.data.message == "User is not logged in.") {
              this.showErrorMessageWithButtonAndRedirect("Ops..", "Favor logar no sistema antes de continuar.", "/login");
            } else {
              this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButton("Ops..", error);

            console.log(error.response.data);
          }
        });
    },

    opcoesHabilitacao(event, habilitacao) {
      this.habilitacao_selecionada = habilitacao;

      let data = {
        habilitacao_id: habilitacao.id,
        acao: this.acao,
      };

      axios
        .post(`/admin/habilitacao/validar`, data)
        .then((response) => {
          if (response.data.success) {
            let newMenu = document.getElementById("newMenu");
            let x = event.clientX - 300;
            let y = event.pageY - 140;

            let winWidth = window.innerWidth;
            let cmWidth = newMenu.offsetWidth;

            x = event.clientX > winWidth - cmWidth ? winWidth - cmWidth - 300 : x;

            console.log("X depois " + x);

            newMenu.style.top = y + "px";
            newMenu.style.left = x + "px";
            newMenu.style.visibility = "visible";
          } else {
            this.showErrorMessageWithButtonAndRedirect("Ops...", response.data.msg, "/admin/habilitacoes");
          }
        })
        .catch((error) => {
          if (typeof error == "object") {
            if (error.response.data.message == "User is not logged in.") {
              this.showErrorMessageWithButtonAndRedirect("Ops..", "Favor logar no sistema antes de continuar.", "/login");
            } else {
              this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButton("Ops..", error);

            console.log(error.response.data);
          }
        });
    },

    bloquear(notificar, habilitacao) {
      if (notificar) {
        document.getElementById("fechar_email_modal").click();
      }

      this.$swal
        .fire({
          title: "Motivo do bloqueio",
          icon: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          html: '<label for="rejeicao">Motivo da rejeição:</label>' + '<textarea id="rejeicao" class="form-control" value="">',
          focusConfirm: false,
          preConfirm: () => {
            return [document.getElementById("rejeicao").value];
          },
        })
        .then((response) => {
          console.log("Response bloqueio");
          console.log(response);

          if (response.isConfirmed) {
            this.habilitacao_selecionada = habilitacao;
            this.isLoading = true;

            let corpo = this.formData.corpo_email;

            corpo = this.formatarVariaveisEmail(corpo, null, this.habilitacao_selecionada.leilao_id);

            console.log("CORPO");
            console.log(corpo);

            let data = {
              habilitacao_id: this.habilitacao_selecionada.id,
              status: "bloqueado",
              notificar: notificar,
              corpo: corpo,
              assunto: this.formData.assunto_email,
              motivo_bloqueio: response.value[0],
            };

            axios
              .post(`/admin/habilitacao/bloquear`, data)
              .then((response) => {
                this.isLoading = false;
                if (response.data.success) {
                  let msg = "Habilitação bloqueada com sucesso.";

                  if (response.data.habilitacoes_pendentes == 1) {
                    msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitação pendente.</b>";
                  } else if (response.data.habilitacoes_pendentes > 1) {
                    msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitações pendentes.</b>";
                  }

                  let that = this;

                  this.$swal
                    .fire({
                      icon: "success",
                      title: "Sucesso",
                      padding: "1.5em",
                      html: msg,
                    })
                    .then(function () {
                      /*
                      let btn = document.getElementById("fechar_email_modal");

                      if (btn) {
                        btn.click();
                      }
                        */

                      that.buscarHabilitacoes();
                    });
                } else {
                  this.showErrorMessageWithButton("Ops...", response.data.msg);
                }
              })
              .catch((error) => {
                this.isLoading = false;
                if (typeof error == "object") {
                  console.log("Erro");
                  console.log(error);

                  if (error.response.data.message == "User is not logged in.") {
                    this.showErrorMessageWithButtonAndRedirect("Ops..", "Favor logar no sistema antes de continuar.", "/login");
                  } else {
                    this.showErrorMessageWithButton("Ops..", error.response.data.message);
                  }
                } else {
                  this.showErrorMessageWithButton("Ops..", error);

                  console.log(error.response.data);
                }
              });
          }
        });
    },

    aprovar(notificar, habilitacao) {
      if (notificar) {
        document.getElementById("fechar_email_modal").click();
      }

      this.habilitacao_selecionada = habilitacao;
      this.isLoading = true;

      let corpo = this.formData.corpo_email;

      corpo = this.formatarVariaveisEmail(corpo, null, this.habilitacao_selecionada.leilao_id);

      console.log("CORPO");
      console.log(corpo);

      let data = {
        habilitacao_id: this.habilitacao_selecionada.id,
        status: "liberado",
        notificar: notificar,
        corpo: corpo,
        assunto: this.formData.assunto_email,
      };

      axios
        .post(`/admin/habilitacao/aprovar`, data)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            let msg = "Usuário habilitado com sucesso.";

            if (response.data.habilitacoes_pendentes == 1) {
              msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitação pendente.</b>";
            } else if (response.data.habilitacoes_pendentes > 1) {
              msg = msg + "<br/>Este usuário possui mais <br/><b>" + response.data.habilitacoes_pendentes + " habilitações pendentes.</b>";
            }

            let that = this;

            this.$swal
              .fire({
                icon: "success",
                title: "Sucesso",
                padding: "1.5em",
                html: msg,
              })
              .then(function () {
                that.buscarHabilitacoes();
              });
          } else {
            this.showErrorMessageWithButton("Ops...", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          if (typeof error == "object") {
            console.log("Erro");
            console.log(error);

            if (error.response.data.message == "User is not logged in.") {
              this.showErrorMessageWithButtonAndRedirect("Ops..", "Favor logar no sistema antes de continuar.", "/login");
            } else {
              this.showErrorMessageWithButton("Ops..", error.response.data.message);
            }
          } else {
            this.showErrorMessageWithButton("Ops..", error);

            console.log(error.response.data);
          }
        });
    },

    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },

    getImagehabilitacao(habilitacao) {
      return process.env.MIX_VUE_APP_habilitacoes_ENDPOINT + "/" + habilitacao.path + "/" + habilitacao.img;
    },

    deletar(habilitacao) {
      console.log("Deletando");
      console.log(habilitacao);

      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Deseja deletar o esta habilitacao? </h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: habilitacao.id,
            };

            axios
              .post(`/admin/habilitacao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("habilitacao deletada!");

                window.location.reload();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    selecionarPagina(pagina) {
      if (pagina <= this.paginas[this.paginas.length - 1] && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + pagina);

        this.buscarHabilitacoes();
      } else if (pagina == this.max_page && pagina > 0) {
        this.inicio = this.qtd_por_pagina * (pagina - 1);
        this.pagina_atual = pagina;

        window.history.replaceState(null, null, "?page=" + this.max_page);

        this.buscarHabilitacoes();
      }
    },

    buscarHabilitacoes(resetar_pagina) {
      if (resetar_pagina) {
        this.pagina_atual = 1;
        this.inicio = 0;
      }

      let data = {
        tipo_exibicao: this.tipo_exibicao,
        apelido: this.apelido,
        leilao_id: this.leilao_id,
        inicio: this.inicio,
        tamanho: this.qtd_por_pagina,
      };

      if (this.dataInicio) {
        console.log("Formatando");
        console.log(this.dataInicio);

        data.data_inicio = this.formatDateToSearch(this.dataInicio);
      }

      if (this.dataFim) {
        data.data_fim = this.formatDateToSearchTime(this.dataFim);
      }

      axios
        .post(`/admin/habilitacoes/search`, data)
        .then((response) => {
          this.habilitacoes = response.data.habilitacoes;

          console.log("habilitacoes");
          console.log(this.habilitacoes);

          this.total = response.data.total;

          for (let i = 0; i < this.habilitacoes.length; i++) {
            this.habilitacoes[i].data_proxima_praca = this.getProximaPraca(this.habilitacoes[i].leilao);
          }

          //ORDENANDO PELA DATA DE SOLICITAÇÃO
          this.habilitacoes.sort(function (a, b) {
            return new Date(a.created_at) - new Date(b.created_at);
          });

          //ORDENANDO PELA DATA DA ÚLTIMA PRAÇA
          this.habilitacoes.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(a.data_proxima_praca) - new Date(b.data_proxima_praca);
          });

          this.pagination(response.data);
        })
        .catch((error) => {
          console.log("Erro");
          console.log(error);

          if (typeof error == "object") {
            this.showErrorMessageWithButton("Ops..", error.response.data.message);
            console.log(error.response.data);
          } else {
            this.showErrorMessageWithButton("Ops..", error);
          }
        });
    },

    formatDateToSearch(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 00:00:00");
    },

    formatDateToSearchTime(date) {
      return moment(date, "yyyy-MM-DD").format("yyyy-MM-DD 23:59:59");
    },

    getProximaPraca(leilao) {
      console.log("Proxima praca");
      console.log(leilao);

      if (leilao.leilao_num_pracas >= 1 && leilao.leilao_1_realizado == 0) {
        return leilao.leilao_1_data;
      }

      if (leilao.leilao_num_pracas >= 2 && leilao.leilao_2_realizado == 0) {
        return leilao.leilao_2_data;
      }

      if (leilao.leilao_num_pracas >= 3 && leilao.leilao_3_realizado == 0) {
        return leilao.leilao_2_data;
      }

      if (leilao.leilao_num_pracas >= 4 && leilao.leilao_4_realizado == 0) {
        return leilao.leilao_4_data;
      }

      return null;
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      this.max_page = Math.ceil(length);

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          length = Math.ceil(length);

          if (length - this.pagina_atual >= 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }

          //CASO O CALCULO O MINIMO SEJA IGUAL A PAGINA ATUAL - 1, REDUZIR 10 DA PAGINA ATUAL CASO ELA SEJA MAIOR QUE 10
          if (i == this.pagina_atual - 1 && this.pagina_atual >= 10) {
            i = this.pagina_atual - 10;
          }

          console.log("I = " + i);
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    alterarQtdPagina() {
      this.pagina_atual = 1;
      this.inicio = 0;

      this.buscarHabilitacoes();
    },

    validateFields() {
      if (!this.nome) {
        this.showErrorMessageWithButton("Ops...", "O campo nome é obrigatório!");
      } else {
        this.create();
      }
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.im {
  width: 1000px;
}

.modal-content {
  width: 1040px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 900px;
    margin-left: -00px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 900px;
    margin-left: -180px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
